import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle2, RotateCcw, Wrench } from "lucide-react";

/**
 * Top-of-panel actions: Return to Production (Testing role),
 * Approve → Dealer Install / Request Change (Agent Review),
 * Resubmit (Production, once every correction is Corrected).
 * Pure presentational — callers own the actual endpoint plumbing.
 */
export default function CorrectionActions({
  showReturnBtn, showAgentReview, showResubmitBtn, canResubmit, busy,
  resubmitLabel,
  onReturnToProd, onAgentApprove, onAgentRequestChange, onResubmit,
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {showReturnBtn && (
        <Button size="sm" variant="outline" onClick={onReturnToProd}
                className="h-9 rounded-sm text-xs border-red-300 text-red-700 hover:bg-red-50"
                data-testid="btn-return-to-production">
          <RotateCcw size={13} className="mr-1.5" /> Return to Production
        </Button>
      )}
      {showAgentReview && (
        <>
          <Button size="sm" onClick={onAgentApprove} disabled={busy}
                  className="h-9 rounded-sm text-xs bg-emerald-600 hover:bg-emerald-700 text-white"
                  data-testid="btn-agent-approve">
            <CheckCircle2 size={13} className="mr-1.5" /> Approve → Dealer Install
          </Button>
          <Button size="sm" variant="outline" onClick={onAgentRequestChange}
                  className="h-9 rounded-sm text-xs border-red-300 text-red-700"
                  data-testid="btn-agent-request-change">
            <Wrench size={13} className="mr-1.5" /> Request Change
          </Button>
        </>
      )}
      {showResubmitBtn && (
        <Button size="sm" onClick={onResubmit} disabled={!canResubmit || busy}
                className="h-9 rounded-sm text-xs bg-[#0B132B] hover:bg-[#1C2541] text-white disabled:opacity-40"
                data-testid="btn-resubmit-to-testing"
                title={!canResubmit ? "Mark all corrections as Corrected first" : ""}>
          <ArrowRight size={13} className="mr-1.5" /> {resubmitLabel}
        </Button>
      )}
    </div>
  );
}
